import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class SoundNotificaionsService {

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get(environment.apiUrl + '/soundnotification');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sound-notificaions.service.ts